import MentoringCompletedRequests from './MentoringCompletedRequests.vue';

export default MentoringCompletedRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/completedrequests/index.ts